import { createRoot } from '../patches/react-dom-client'
import { Router } from 'react-router'
import { CompatRouter } from 'react-router-dom-v5-compat'
import '../css/app' // all-in-one for now
import Main from '../containers/mainOneappNew'
import { inited, history } from '../framework/states'
import { SPARKY_ROOT_ELEMENT_TAG_NAME, DEFAULT_ROOT_ELEMENT_ID } from '../init/initConst'
import { getRootElement } from '../framework/loadingMask'
import type { VFC } from 'react'
import type { SparkySettings } from '../framework/microAppTypes'

const App: VFC<{ settings: SparkySettings }> = ({ settings }) => {
  return (
    <Router history={history}>
      <CompatRouter>
        <Main settings={settings} />
      </CompatRouter>
    </Router>
  )
}

const getAndRenameRootElement = (): HTMLElement => {
  const rootEl = getRootElement()
  if (!rootEl) {
    const newEl = document.createElement(SPARKY_ROOT_ELEMENT_TAG_NAME)
    newEl.id = DEFAULT_ROOT_ELEMENT_ID
    newEl.className = 'loading'
    document.body.appendChild(newEl)
    return newEl
  }
  if (rootEl.id !== DEFAULT_ROOT_ELEMENT_ID) {
    rootEl.id = DEFAULT_ROOT_ELEMENT_ID // TODO: once migrate away css rules, remove this
  }
  if (rootEl.tagName.toLowerCase() === SPARKY_ROOT_ELEMENT_TAG_NAME) {
    return rootEl
  }
  if (rootEl.parentNode) {
    const newEl = document.createElement(SPARKY_ROOT_ELEMENT_TAG_NAME)
    for (const attr of Array.from(rootEl.attributes)) {
      newEl.setAttribute(attr.name, attr.value)
    }
    while (rootEl.firstChild) {
      newEl.appendChild(rootEl.firstChild)
    }
    rootEl.parentNode.replaceChild(newEl, rootEl)
    return newEl
  }
  return rootEl
}

const render = (settings: SparkySettings) => {
  Object.defineProperties(inited, { settings: { value: settings } })
  const root = createRoot(getAndRenameRootElement())
  root.render(
    <App settings={settings} />
  )
  inited.resolve(settings)
}

export default render
